import Image from 'next/image';

import Delivery2x from '@/assets/blog/travel/delivery@2x.jpg';
import FamilyFriendly2x from '@/assets/blog/travel/family-friendly@2x.jpg';
import InstantBook2x from '@/assets/blog/travel/instantbook@2x.jpg';
import PetFriendly2x from '@/assets/blog/travel/pet-friendly@2x.jpg';
import Under1502x from '@/assets/blog/travel/under-150@2x.jpg';
import AspectRatio from '@/components/common/AspectRatio';
import { trackEvent } from '@/services/track-event';

import css from './RentalRigs.module.css';

const RentalRigs = () => {
  const searchUrl = (params: Record<string, unknown>) => {
    const queryString = Object.entries(params)
      .map(([key, value]) => `${key}=${value}`)
      .join('&');
    return `${process.env.hostApp}/rv-search?${queryString}`;
  };

  const trackLinkClicked = (data: Record<string, unknown>) => {
    trackEvent({
      event: 'Blog : Clicked riglist item',
      data,
    });
  };

  return (
    <ul className={css.rigsList}>
      {rigs.map(rig => {
        const { params, image, name } = rig;
        return (
          <li className={css.rigItem} key={name}>
            <a
              title={name}
              href={searchUrl(params)}
              className="relative block h-full overflow-hidden rounded"
              onClick={() => trackLinkClicked({ typeOf: 'rig', name })}>
              <AspectRatio
                ratio="320:564"
                hasImageHover={true}
                className="bg-gray-100 shadow hover:shadow-lg">
                <Image
                  src={image}
                  alt=""
                  sizes="(min-width: 768px) 10vw, 50vw"
                  className="object-cover"
                  fill
                />
              </AspectRatio>
              <div className="absolute bottom-0 left-0 content-end w-full p-3 text-white grid lg:p-4 lg:pt-8 h-36 bg-gradient-to-t from-gray-900">
                <div className="mt-4 text-center highlight autoType600 text">{name}</div>
              </div>
            </a>
          </li>
        );
      })}
    </ul>
  );
};

export default RentalRigs;

const rigs = [
  {
    name: 'Delivery',
    image: Delivery2x,
    params: { delivery: true },
  },
  {
    name: 'Pet Friendly',
    image: PetFriendly2x,
    params: {
      'filter[feature]': 'pet_friendly',
    },
  },
  {
    name: 'Under 150',
    image: Under1502x,
    params: { 'price[max]': '15000' },
  },
  {
    name: 'Family friendly',
    price: '81',
    image: FamilyFriendly2x,
    params: { 'filter[type]': 'a,c,b,trailer,truck-camper,camper-van' },
  },
  {
    name: 'Instant Bookable',
    image: InstantBook2x,
    params: { 'filter[type]': 'fifth-wheel' },
  },
];
